import React from 'react'

function IconBoxQ14({ fill, stroke }) {
  return (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 12.5V6.5V4.5C1 2.29086 2.79086 0.5 5 0.5H7H13V6.5V8.5C13 10.7091 11.2091 12.5 9 12.5H7H1Z" fill={fill} />
      <path d="M9 6.5V6.5C9 7.60457 8.10457 8.5 7 8.5H4.99165V6.5C4.99165 5.39543 5.88708 4.5 6.99165 4.5H9V6.5ZM9 6.5V12.5M7 0.5H5C2.79086 0.5 1 2.29086 1 4.5V6.5V12.5H7H9C11.2091 12.5 13 10.7091 13 8.5V6.5V0.5H7Z" stroke={stroke} />
    </svg>
  )
}

export default IconBoxQ14